import { RECEIVED_UPLOAD } from "types/actions/upload"

export const receiveUpload = (file = "", uploadType = "image") => ({
  type: RECEIVED_UPLOAD,
  file,
  uploadType
})

export const resizeImage = (base64Str, maxWidth, maxHeight) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const type =
        base64Str.split(",")[0].indexOf("png") !== -1
          ? "image/png"
          : "image/jpeg"

      var img = new Image()
      img.src = base64Str
      img.onload = function() {
        var canvas = document.createElement("canvas")
        var MAX_WIDTH = maxWidth
        var MAX_HEIGHT = maxHeight
        var width = img.width
        var height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }
        canvas.width = width
        canvas.height = height
        var ctx = canvas.getContext("2d")
        ctx.drawImage(img, 0, 0, width, height)
        resolve(canvas.toDataURL(type, 1))
      }
    })
    return deferred
  }
}



// WEBPACK FOOTER //
// ./src/actions/upload.js